import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Document } from 'src/app/models/document.model';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { JobDocumentsModel, SubRehababilitationModel } from 'src/app/case-application/substanial-rehabilitation/models/sub-rehab.model';
import { SubRehabilitationService } from 'src/app/case-application/substanial-rehabilitation/services/sub-rehabilitation.service';

@Component({
    selector: 'app-upload-wrapper',
    templateUrl: './upload-wrapper.component.html',
})
export class UploadWrapperComponent implements OnInit {
    @Input() jobIndex: number;
    @Input() targetDocumentList: 'ApplicationDetailDOB' | 'CertificateOccupancy' | 'ArchitectAffidavit' | 'JobFileDOB' |
        'TaxAbatement' | 'rehabAmountPaymentProofs' | 'jobFile' | 'Deed' | 'ProofCondition' | 'Photo';
    @Input() isMultiple = false;
    @Input() list: any[];
    @Input() jobDocuments: JobDocumentsModel;
    @Output() documentList: EventEmitter<Document[]> = new EventEmitter();
    @Output() uploadedDocument: EventEmitter<Document> = new EventEmitter();
    @Output() handleDelete: EventEmitter<Document> = new EventEmitter();
    // @Output() uploadFileList: EventEmitter<Document> = new EventEmitter();
    // @Output() beforeList: EventEmitter<Document[]> = new EventEmitter();
    // @Output() afterList: EventEmitter<Document[]> = new EventEmitter();

    model$: Observable<SubRehababilitationModel> = this.subRehabSrvc.subRehabilitationModelSubject.asObservable();
    model: SubRehababilitationModel = null;

    metaList: JobDocumentsModel = null;
    transactionGuid: string;
    fileTemp: File;

    documentType = '';

    metaData: Partial<JobDocumentsModel> = null;

    uploadedDocumentSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
    uploadedDocument$: Observable<any[]> = this.uploadedDocumentSubject.asObservable();
    transactionId: string;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private subRehabSrvc: SubRehabilitationService,
        private toastrService: ToastrService,
    ) {

    }

    ngOnInit() {
        this.uploadedDocumentSubject.next(this.list);
        if (this.targetDocumentList === null || this.targetDocumentList === undefined) {
            throw new Error('You must provide a targetDocumentList');
        }
        this.runModelChecks(this.subRehabSrvc.subRehabilitationModelSubject.getValue());
    }

    async onAdd(file: File) {
        if (file === null || file === undefined) {
            return true;
        }

        const data = new FormData();
        data.append('DocumentTypeCode', this.targetDocumentList !== 'rehabAmountPaymentProofs' ?
            this.targetDocumentList : 'ApplicationDetailDOB');
        data.append('AttachedFile', file);

        this.upload(data);
    }

    runModelChecks(model: SubRehababilitationModel): void {
        this.model = model;
        switch (this.targetDocumentList) {
            case 'ApplicationDetailDOB':
                this.list = this.jobDocuments.ApplicationDetailDOB;
                break;
            case 'ArchitectAffidavit':
                this.list = this.jobDocuments.ArchitectAffidavit;
                break;
            case 'CertificateOccupancy':
                this.list = this.jobDocuments.CertificateOccupancy;
                break;
            case 'JobFileDOB':
                this.list = this.jobDocuments.JobFileDOB;
                break;
            case 'TaxAbatement':
                this.list = this.jobDocuments.TaxAbatement;
                break;
        }
        this.uploadedDocumentSubject.next(this.list);
        this.documentList.emit(this.list);
    }

    onDelete(document: any) {
        const documentId = document.id ? document.id : document.incidentActivityDocumentID;
        this.subRehabSrvc.deleteDocument(documentId).subscribe(response => {
            this.toastrService.success('Document Deleted successfully', 'Delete Success');
            const uploadedDocumentUnSubscription$ = new Subject<void>();
            this.uploadedDocument$.pipe(takeUntil(uploadedDocumentUnSubscription$)).subscribe((documentList) => {
                const deletedDoc = documentList.filter((doc) => {
                    return doc.id === documentId;
                });
                documentList = documentList.filter((doc) => {
                    return doc.id !== documentId;
                });

                uploadedDocumentUnSubscription$.next();
                uploadedDocumentUnSubscription$.complete();
                this.uploadedDocumentSubject.next(documentList);
                this.list = documentList;
                this.handleDelete.emit(deletedDoc[0]);
            });
        }, errors => {
            this.toastrService.error('Document Deletion failed', 'Delete failed');
        });
    }

    onViewDocument(documentId: string) {
        this.subRehabSrvc.viewDocument(documentId).subscribe(response => {
            const blob = new Blob([response], { type: response.type });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        }, errors => {
            this.toastrService.error('Viewing Document failed', 'File retrieval failed');
        });
    }

    private upload(formData: FormData) {
        this.subRehabSrvc.uploadDocument(formData).subscribe(fileData => {
            const docTypeCode = new CodeDescriptionModel({ code: fileData.documentType.code,
                description: fileData.documentType.description, shortName: fileData.documentType.shortName });
            const fileObj: any = {
                documentTypeCode: docTypeCode,
                otherDocumentType: fileData.fileType,
                documentDescription: null,
                id: fileData.incidentActivityDocumentID,
                fileName: fileData.fileName,
                sectionName: null
            };
            this.uploadedDocument.emit(fileObj);
            if (this.isMultiple) {
                const uploadedDocumentUnSubscription$ = new Subject<void>();
                this.uploadedDocument$.pipe(takeUntil(uploadedDocumentUnSubscription$)).subscribe((documentList) => {
                    if (documentList && documentList.length > 0) {
                        if (documentList[0].id !== fileObj.id) {
                            documentList = documentList.concat([fileObj]);
                        }
                    } else {
                        documentList = [fileObj];
                    }
                    uploadedDocumentUnSubscription$.next();
                    uploadedDocumentUnSubscription$.complete();
                    this.uploadedDocumentSubject.next(documentList);
                    this.list = documentList;
                });
            } else {
                this.uploadedDocumentSubject.next([fileObj]);
                this.list = [fileObj];
            }
            this.toastrService.success('Document Uploaded successfully', 'Document Upload');
        }, (error) => {
            this.toastrService.error('Failed', 'Document Upload');
        });
    }

    getDocList() {
        return this.list;
    }

    getFormData() {
        return this.list;
    }
    setFormData(documentList: any) {
        if (Array.isArray(documentList)) {
            this.uploadedDocumentSubject.next(documentList);
            this.list = documentList;
            this.changeDetectorRef.detectChanges();
        }
    }
}
